module.exports = __webpack_public_path__ + "img/bottom_gg.2809d624.png";